module.exports = __webpack_public_path__ + "img/AT.bf7ea5b6.jpg";